const $ = jQuery.noConflict();

class Accordions {
    constructor(trigger) {
        this.trigger = $(trigger);
        this.accordionAllButton = $('.single-accordion__all-button');
    }
    init() {
        this.bindEvents();
    }
    bindEvents() {
        this.trigger.on('click', this.toggleAccordion);
        this.accordionAllButton.on('click', this.toggleAccordionAll);
    }
    toggleAccordion() {
        $(this).parent().toggleClass('active');
        $(this).next().stop().slideToggle(250);
    }
    toggleAccordionAll() {
        var accordionID = $(this).attr('data-target');

        if ($(this).hasClass('expanded')) {
            $(this).removeClass('expanded');
            $('#' + accordionID).find('.single-accordion__content').slideUp(250);
            $('#' + accordionID).find('.single-accordion').removeClass('active');
        } else {
            $(this).addClass('expanded');
            $('#' + accordionID).find('.single-accordion__content').slideDown(250);
            $('#' + accordionID).find('.single-accordion').addClass('active');
        }
    }
}

export default new Accordions('.single-accordion__title');
